import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        padding: "0px 22px 22px 22px",
    },
    mainCard: {
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(5),
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        borderRadius: 4,
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(5),
    },
    cardHeaderTitle: {
        color: theme.palette.info.main,
        fontSize: 18,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
    },
    cardHeaderActions: {
        display: "flex",
    },
    cardHeaderAction: {
        color: theme.palette.info.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        fontWeight: 700,
        fontSize: 12,
        fontFamily: "Source Sans 3",
        textTransform: "uppercase",
        cursor: "pointer",
        "& span:hover": {
            textDecoration: "underline",
        },
    },
    cardHeaderActionIcon: {
        width: "18px !important",
        height: "18px !important",
    },
    cardContent: {
        display: "flex",
        flexDirection: "column",
    },
    tableHeaderCell: {
        color: `${theme.palette.primary.dark} !important`,
        fontFamily: "Source Sans 3 !important",
        fontSize: "12px !important",
        fontWeight: "700 !important",
        textTransform: "uppercase",
        borderTop: `1px solid ${theme.palette.border.select} !important`,
        borderBottom: `1px solid ${theme.palette.border.select} !important`,
        padding: "8px !important",
    },
    tableBodyCell: {
        padding: "16px 8px !important",
        fontFamily: "Source Sans 3 !important",
        color: `${theme.palette.primary.darker} !important`,
        "& a": {
            fontFamily: "Source Sans 3 !important",
            color: `${theme.palette.info.main} !important`,
            textDecoration: "none",
        },
    },
    tableAvatar: {
        width: `30px !important`,
        height: `30px !important`,
        fontSize: "12px !important",
    },
    tableBodyCellActionButton: {
        color: `${theme.palette.info.main} !important`,
        padding: "0 !important",
    },
    mainCardLoading: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
    },
    table: {
        minWidth: `650px !important`,
    },
}));
